import { StatisticalAnalysisSidebarBase, StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { uniqueId } from 'lodash'
import { StatisticalAnalysisHeaderNavigationItems, StatisticalAnalysisHeaderValues, StatisticalAnalysisTypeNavigation } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { StatisticalAnalysisCaseTypes, StatisticalAnalysisDossiers, StatisticalAnalysisEnumsAndKeys, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisTemporalFilterEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import { LaboratoryStatisticalAnalysisSidebarDateInput } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'

export interface StatisticalAnalysisGeneralDossierModelSearchInfo {
    typeSearch: Nullable<StatisticalAnalysisSidebarItemCombo>
    laboratories: Nullable<LaboratoryStatisticalAnalysisSidebarDateInput[]>
    startDate: Nullable<Date>
    endDate: Nullable<Date>
    typeIds: Nullable<StatisticalAnalysisSidebarItemCombo[]>
}

export interface StatisticsAnalysisGeneralStatisticsTrackingItems extends Partial<StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisCaseTypes>> {
    label: string
    key: StatisticalAnalysisCaseTypes
    value: number
    percent: number
    active: boolean
}

export interface StatisticalAnalysisGeneralDossierExternalInfo extends StatisticalAnalysisGeneralDossierModelSearchInfo{
    sameRange: boolean
    trackingItems: StatisticsAnalysisGeneralStatisticsTrackingItems[]
    trackingGeneralSelected: Nullable<StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisCaseTypes>>
    trackingDetailSelected: Nullable<StatisticalInfoPaginatorTrackingItems>
}
export interface StatisticalAnalysisDossierGeneralStatisticsState extends StatisticalAnalysisSidebarBase {
    headerData: StatisticalAnalysisHeaderValues
    viewDetail: StatisticalAnalysisViewDetailParams
    externalInfo: StatisticalAnalysisGeneralDossierExternalInfo
    generalView: boolean
    promiseGeneralView: Nullable<Promise<void>>

}
export const initialStatisticalAnalysisDossierGeneralStatisticsState =
    (): StatisticalAnalysisDossierGeneralStatisticsState => ({
        sidebar: {
            title: 'statisticalAnalysis.sections.generalStatistics',
            id: 'general-statistics',
            components: [
                {
                    name: 'StatisticalAnalysisSidebarSearchBy',
                    id: uniqueId(),
                    props: {
                        filterByEntityTypes: true,
                        options: [
                            StatisticalAnalysisEnumsAndKeys.CASE.getModel(),
                            StatisticalAnalysisEnumsAndKeys.SAMPLE.getModel(),
                            StatisticalAnalysisEnumsAndKeys.PORTION.getModel(),
                            StatisticalAnalysisEnumsAndKeys.SUBPORTION.getModel()
                        ],
                        preselection: StatisticalAnalysisEnumsAndKeys.CASE.getModel()
                    }
                },
                {
                    name: 'StatisticalAnalysisSidebarDateAndCenters',
                    id: uniqueId(),
                    props: { }
                }
            ]
        },
        externalInfo: {
            typeSearch: null,
            laboratories: [],
            startDate: null,
            endDate: null,
            sameRange: false,
            trackingDetailSelected: null,
            trackingGeneralSelected: null,
            trackingItems: [],
            typeIds: null
        },
        headerData: {
            header: {
                total: 0,
                showTotal: true,
                startDate: new Date(),
                endDate: new Date(),
                elementType: ''
            },
            navigationItems: [],
            navigationType: StatisticalAnalysisTypeNavigation.NAVIGATION,
            styles: {
                background: require('@/img/general-statistics-case-bg.jpg'),
                icon: ''
            }
        },
        viewDetail: {
            dossier: StatisticalAnalysisDossiers.GENERAL,
            table: {
                contextMenuItems: {
                    detailChart: false,
                    detailList: true
                },
                temporalFilter: {
                    isShow: true,
                    preselection: StatisticalAnalysisTemporalFilterEnum.DAYS
                }
            },
            chart: {
                axis: {
                    xAxis: {
                        show: true,
                        mainCombo: {
                            list: [],
                            selected: null
                        },
                        associatedCombo: {
                            list: [],
                            selected: null
                        }
                    },
                    yAxis: {
                        show: false
                    }
                },
                showExtendedFilters: false
            }
        },
        generalView: true,
        promiseGeneralView: null
    })
